import { IRequestBase } from 'types';
import { IApplication, UserFeedbackStatus } from '../../reducers/userApplications/type';
import { AppThunk } from '../../store';

export enum TypesUserApplication {
  GET_USER_APPLICATIONS_REQUEST = 'user.GET_USER_APPLICATIONS_REQUEST',
  GET_USER_APPLICATIONS_SUCCESS = 'user.GET_USER_APPLICATIONS_SUCCESS',
  GET_USER_APPLICATIONS_ERROR = 'user.GET_USER_APPLICATIONS_ERROR',

  GET_USER_LOANS_REQUEST = 'user.GET_USER_LOANS_REQUEST',
  GET_USER_LOANS_SUCCESS = 'user.GET_USER_LOANS_SUCCESS',
  GET_USER_LOANS_ERROR = 'user.GET_USER_LOANS_ERROR',

  GET_USER_LOAN_INFO_REQUEST = 'user.GET_USER_LOAN_INFO_REQUEST',
  GET_USER_LOAN_INFO_SUCCESS = 'user.GET_USER_LOAN_INFO_SUCCESS',
  GET_USER_LOAN_INFO_ERROR = 'user.GET_USER_LOAN_INFO_ERROR',

  GET_PAYMENT_PLAN_INFO_REQUEST = 'user.GET_PAYMENT_PLAN_INFO_REQUEST',
  GET_PAYMENT_PLAN_INFO_SUCCESS = 'user.PAYMENT_PLAN_INFO_SUCCESS',
  GET_PAYMENT_PLAN_INFO_ERROR = 'user.PAYMENT_PLAN_INFO_ERROR',

  GET_APPLICATION_AGREEMENTS_SUCCESS = 'user.GET_APPLICATION_AGREEMENTS_SUCCESS',
  GET_APPLICATION_AGREEMENTS_ERROR = 'user.GET_APPLICATION_AGREEMENTS_ERROR',

  GET_ALL_APPLICATION_AGREEMENTS_REQUEST = 'user.GET_ALL_APPLICATION_AGREEMENTS_REQUEST',
  GET_ALL_APPLICATION_AGREEMENTS_SUCCESS = 'user.GET_ALL_APPLICATION_AGREEMENTS_SUCCESS',
  GET_ALL_APPLICATION_AGREEMENTS_ERROR = 'user.GET_ALL_APPLICATION_AGREEMENTS_ERROR',

  POST_CREATE_APPLICATION_REQUEST = 'user.POST_CREATE_APPLICATION_REQUEST',
  POST_CREATE_APPLICATION_SUCCESS = 'user.POST_CREATE_APPLICATION_SUCCESS',
  POST_CREATE_APPLICATION_ERROR = 'user.POST_CREATE_APPLICATION_ERROR',

  POST_PAYMENT_APPLICATION_REQUEST = 'user.POST_PAYMENT_APPLICATION_REQUEST',
  POST_PAYMENT_APPLICATION_SUCCESS = 'user.POST_PAYMENT_APPLICATION_SUCCESS',
  POST_PAYMENT_APPLICATION_ERROR = 'user.POST_PAYMENT_APPLICATION_ERROR',
  POST_REPAYMENT_APPLICATION_REQUEST = 'user.POST_REPAYMENT_APPLICATION_REQUEST',
  POST_REPAYMENT_APPLICATION_SUCCESS = 'user.POST_REPAYMENT_APPLICATION_SUCCESS',
  POST_REPAYMENT_APPLICATION_ERROR = 'user.POST_REPAYMENT_APPLICATION_ERROR',

  POST_CREATE_PAYMENTLINK_REQUEST = 'user.POST_CREATE_PAYMENTLINK_REQUEST',
  POST_CREATE_PAYMENTLINK_SUCCESS = 'user.POST_CREATE_PAYMENTLINK_SUCCESS',
  POST_CREATE_PAYMENTLINK_ERROR = 'user.POST_CREATE_PAYMENTLINK_ERROR',

  GET_ACTIVE_PAYMENTLINK_REQUEST = 'user.GET_ACTIVE_PAYMENTLINK_REQUEST',
  GET_ACTIVE_PAYMENTLINK_SUCCESS = 'user.GET_ACTIVE_PAYMENTLINK_SUCCESS',
  GET_ACTIVE_PAYMENTLINK_ERROR = 'user.GET_ACTIVE_PAYMENTLINK_ERROR',

  GET_LOANS_PAYMENTS_REQUEST = 'user.GET_LOANS_PAYMENTS_REQUEST',
  GET_LOANS_PAYMENTS_SUCCESS = 'user.GET_LOANS_PAYMENTS_SUCCESS',
  GET_LOANS_PAYMENTS_ERROR = 'user.GET_LOANS_PAYMENTS_ERROR',

  GET_PAYMENT_SUBSCRIPTION_SUCCESS = 'user.GET_PAYMENT_SUBSCRIPTION_SUCCESS',
  GET_PAYMENT_SUBSCRIPTION_ERROR = 'user.GET_PAYMENT_SUBSCRIPTION_ERROR',

  POST_SKIP_PAYMENT_SUBSCRIPTION_REQUEST = 'SKIP_PAYMENT_SUBSCRIPTION',
  POST_SKIP_PAYMENT_SUBSCRIPTION_SUCCESS = 'user.POST_SKIP_PAYMENT_SUBSCRIPTION_SUCCESS',
  POST_SKIP_PAYMENT_SUBSCRIPTION_ERROR = 'user.POST_SKIP_PAYMENT_SUBSCRIPTION_ERROR',

  GET_CONFIRM_CODE_APPLICATION_REQUEST = 'user.GET_CONFIRM_CODE_APPLICATION_REQUEST',
  GET_CONFIRM_CODE_APPLICATION_SUCCESS = 'user.GET_CONFIRM_CODE_APPLICATION_SUCCESS',
  GET_CONFIRM_CODE_APPLICATION_ERROR = 'user.GET_CONFIRM_CODE_APPLICATION_ERROR',

  POST_CONFIRM_CODE_APPLICATION_REQUEST = 'user.POST_CONFIRM_CODE_APPLICATION_REQUEST',
  POST_CONFIRM_CODE_APPLICATION_SUCCESS = 'user.POST_CONFIRM_CODE_APPLICATION_SUCCESS',
  POST_CONFIRM_CODE_APPLICATION_ERROR = 'user.POST_CONFIRM_CODE_APPLICATION_ERROR',

  POST_INIT_ESIGN_REQUEST = 'user.POST_INIT_ESIGN_REQUEST',
  POST_INIT_ESIGN_SUCCESS = 'user.POST_INIT_ESIGN_SUCCESS',
  POST_INIT_ESIGN_ERROR = 'user.POST_INIT_ESIGN_ERROR',

  GET_DOWNLOAD_AGREEMENTS_REQUEST = 'user.GET_DOWNLOAD_AGREEMENTS_REQUEST',
  GET_DOWNLOAD_AGREEMENTS_SUCCESS = 'user.GET_DOWNLOAD_AGREEMENTS_SUCCESS',
  GET_DOWNLOAD_AGREEMENTS_ERROR = 'user.GET_DOWNLOAD_AGREEMENTS_ERROR',

  GET_DOWNLOAD_EXPERIAN_REPORT_REQUEST = 'user,GET_DOWNLOAD_EXPERIAN_REPORT_REQUEST',
  GET_DOWNLOAD_EXPERIAN_REPORT_SUCCESS = 'user.GET_DOWNLOAD_EXPERIAN_REPORT_SUCCESS',
  GET_DOWNLOAD_EXPERIAN_REPORT_ERROR = 'user.GET_DOWNLOAD_EXPERIAN_REPORT_ERROR',

  GET_DOWNLOAD_SIGNED_DOCUMENTS_REQUEST = 'user.GET_DOWNLOAD_SIGNED_DOCUMENTS_REQUEST',
  GET_DOWNLOAD_SIGNED_DOCUMENTS_SUCCESS = 'user.GET_DOWNLOAD_SIGNED_DOCUMENTS_SUCCESS',
  GET_DOWNLOAD_SIGNED_DOCUMENTS_ERROR = 'user.GET_DOWNLOAD_SIGNED_DOCUMENTS_ERROR',

  GET_LIST_OF_BANKS_SUCCESS = 'user.GET_LIST_OF_BANKS_SUCCESS',
  GET_LIST_OF_BANKS_ERROR = 'user.GET_LIST_OF_BANKS_ERROR',

  GET_LIST_OF_STATES_SUCCESS = 'user.GET_LIST_OF_STATES_SUCCESS',
  GET_LIST_OF_STATES_ERROR = 'user.GET_LIST_OF_STATES_ERROR',

  GET_LIST_OF_EDUCATION_SUCCESS = 'user.GET_LIST_OF_EDUCATION_SUCCESS',
  GET_LIST_OF_EDUCATION_ERROR = 'user.GET_LIST_OF_EDUCATION_ERROR',

  GET_LIST_OF_MARITAL_STATUS_SUCCESS = 'user.GET_LIST_OF_MARITAL_STATUS_SUCCESS',
  GET_LIST_OF_MARITAL_STATUS_ERROR = 'user.GET_LIST_OF_MARITAL_STATUS_ERROR',

  GET_LIST_OF_LOAN_PURPOSES_REQUEST = 'user.GET_LIST_OF_LOAN_PURPOSES_REQUEST',
  GET_LIST_OF_LOAN_PURPOSES_SUCCESS = 'user.GET_LIST_OF_LOAN_PURPOSES_SUCCESS',
  GET_LIST_OF_LOAN_PURPOSES_ERROR = 'user.GET_LIST_OF_LOAN_PURPOSES_ERROR',

  POST_FINBIT_REQUEST = 'user.POST_FINBIT_REQUEST',
  POST_FINBIT_SUCCESS = 'user.POST_FINBIT_SUCCESS',
  POST_FINBIT_ERROR = 'user.POST_FINBIT_ERROR',

  GET_FINBIT_REQUEST = 'user.GET_FINBIT_REQUEST',
  GET_FINBIT_SUCCESS = 'user.GET_FINBIT_SUCCESS',
  GET_FINBIT_ERROR = 'user.GET_FINBIT_ERROR',

  GET_SUMMARY_APPLICATION_SUCCESS = 'user.GET_SUMMARY_APPLICATION_SUCCESS',
  GET_SUMMARY_APPLICATION_ERROR = 'user.GET_SUMMARY_APPLICATION_ERROR',

  POST_USER_FEEDBACK_SUCCESS = 'user.POST_USER_FEEDBACK_SUCCESS',
  POST_USER_FEEDBACK_ERROR = 'user.POST_USER_FEEDBACK_ERROR',

  GET_CUSTOM_PAYMENT_INFO_REQUEST = 'user.GET_CUSTOM_PAYMENT_INFO_REQUEST',
  GET_CUSTOM_PAYMENT_INFO_SUCCESS = 'user.GET_CUSTOM_PAYMENT_INFO_SUCCESS',
  GET_CUSTOM_PAYMENT_INFO_ERROR = 'user.GET_CUSTOM_PAYMENT_INFO_ERROR',

  POST_CREATE_CUSTOM_PAYMENT_LINK_REQUEST = 'user.POST_CREATE_CUSTOM_PAYMENT_LINK_REQUEST',
  POST_CREATE_CUSTOM_PAYMENT_LINK_SUCCESS = 'user.POST_CREATE_CUSTOM_PAYMENT_LINK_SUCCESS',
  POST_CREATE_CUSTOM_PAYMENT_LINK_ERROR = 'user.POST_CREATE_CUSTOM_PAYMENT_LINK_ERROR',

  GET_CASH_FREE_PAYMENT_SESSION_REQUEST = 'user.GET_CASH_FREE_PAYMENT_SESSION_REQUEST',
  GET_CASH_FREE_PAYMENT_SESSION_SUCCESS = 'user.GET_CASH_FREE_PAYMENT_SESSION_SUCCESS',
  GET_CASH_FREE_PAYMENT_SESSION_ERROR = 'user.GET_CASH_FREE_PAYMENT_SESSION_ERROR',
}

export interface IPostCreateApplicationData extends IRequestBase {
  data: {
    loan_purpose?: number;
    principal: number | string;
    tenor: number | string;
    product_id?: number;
    promo_code?: string;
  };
}

export type IPostCreateApplicationType = (data: IPostCreateApplicationData) => AppThunk<void>;

export interface IConfirmApplicationData extends IRequestBase {
  values: Partial<IApplication>;
}

export type PostInitEsignType = (params?: IRequestBase) => AppThunk<void>;
export type IConfirmApplicationType = (data: IConfirmApplicationData) => AppThunk<void>;

export type GetListOfBanksType = () => AppThunk<void>;

export type GetListOfLoanPurposesType = () => AppThunk<void>;

export type GetListOfEducationType = () => AppThunk<void>;

export type GetListOfMaritalStatusesType = () => AppThunk<void>;

export type GetListOfStatesType = () => AppThunk<void>;

export type GetUserLoans = () => AppThunk<void>;

export type GetUserInfo = (userId?: number) => AppThunk<void>;

export type GetUserApplications = () => AppThunk<void>;

export type GetPaymentPlanInfo = () => AppThunk<void>;

export type GetPaymentSubscription = () => AppThunk<void>;

export type GetSummaryApplication = () => AppThunk<void>;

export interface IRepaymentApplication {
  amount_requested: number;
  gateway?: string | undefined;
  for_extension?: boolean;
  extension_tenor?: string | number;
}

export interface IExtendApplication {
  amount: number;
  gateway?: string | undefined;
  for_extension: boolean;
  extension_tenor: string | number;
  tenor?: string | number;
}

export interface IRequiredPayForApplication {
  amount: number;
  gateway?: string | undefined;
}

export type GetDownloadApplicationAgreements = (
  agreementId: number,
  agreementName: string
) => AppThunk<void>;

export type GetALLApplicationAgreements = () => AppThunk<void>;

export type PostUserFeedbackType = (
  data: {
    user_feedback_status: UserFeedbackStatus;
    user_feedback_detail?: string;
    user_feedback_text?: string;
  } & IRequestBase
) => AppThunk<void>;

export type GetCustomPaymentInfoType = (
  data: {
    slug: string;
  } & IRequestBase
) => AppThunk<void>;

export type CreateCustomPaymentLinkType = (
  data: {
    slug: string;
    amount: number;
  } & IRequestBase
) => AppThunk<void>;
